export default "__VITE_ASSET__dxg9Zkr7__"